import './_grid.sass'

import Grid from './grid'

export default Grid('layout')



// WEBPACK FOOTER //
// ../../../src/components/VGrid/VLayout.ts